import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Note } from '../../../../../../../../entities/ApplicationFeed';
import { LoadingSpinnerIconSpan } from '../../../../../../../../components/LoadingSpinnerIconSpan';
import { NoteEntry } from '../NoteEntry';
import { MAX_NOTES } from '..';

interface PropTypes {
  notes: Note[];
  hasMore: boolean;
  totalCount: number;
  scrollableTarget: string;
  loadNotes: () => void;
}

export function NotesList(props: PropTypes) {
  return (
    <InfiniteScroll
      dataLength={props.notes.length}
      next={props.loadNotes}
      hasMore={props.hasMore}
      loader={
        <LoadingSpinnerIconSpan
          className='mt-2 mb-3'
          iconClassName='text-blue-500'
          textClassName='text-dark-200 ps-2 fs-6'
          text='Loading'
        />
      }
      scrollableTarget={props.scrollableTarget}
    >
      {props.notes.map((note) => (
        <NoteEntry key={note.id} note={note} />
      ))}
      {props.notes.length >= MAX_NOTES && props.totalCount > MAX_NOTES && (
        <p className='text-muted fs-6 text-center mt-2 mb-3'>
          Showing the {MAX_NOTES} most recent notes. For the full history, view
          the candidate profile.
        </p>
      )}
    </InfiniteScroll>
  );
}
